import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTrash2, FiPlus, FiClock } = FiIcons;
const TYPES = ['dialogue', 'action', 'shot', 'camera', 'audio', 'vfx', 'transition', 'environment'];

export default function Timeline({ cues, setCues, currentTime, onSeek }) {
  const update = (index, field, value) => {
    setCues(cues.map((cue, i) => i === index ? { ...cue, [field]: value } : cue));
  };
  const remove = (index) => setCues(cues.filter((_, i) => i !== index));
  const add = () => setCues([...cues, {
    type: 'action', selectedText: '', startTime: currentTime, endTime: currentTime + 1, speaker: null
  }]);

  return (
    <section className="timeline">
      <div className="timeline-title">
        <div><h2>Synchronization cues</h2><p>{cues.length} timeline events</p></div>
        <button className="quiet-button" onClick={add}><SafeIcon icon={FiPlus} /> Add cue</button>
      </div>
      {!cues.length ? (
        <div className="empty-state"><SafeIcon icon={FiClock} /><p>Generated cues will appear here for review.</p></div>
      ) : (
        <div className="cue-list">
          {cues.map((cue, index) => (
            <article className="cue-card" key={`${cue.startTime}-${index}`} onClick={() => onSeek(cue.startTime)}>
              <select value={cue.type} onClick={(e) => e.stopPropagation()} onChange={(e) => update(index, 'type', e.target.value)}>
                {TYPES.map((type) => <option key={type}>{type}</option>)}
              </select>
              <div className="cue-copy">
                <textarea value={cue.selectedText} onClick={(e) => e.stopPropagation()} onChange={(e) => update(index, 'selectedText', e.target.value)} />
                <input value={cue.speaker || ''} placeholder="SPEAKER" onClick={(e) => e.stopPropagation()} onChange={(e) => update(index, 'speaker', e.target.value.toUpperCase() || null)} />
              </div>
              <div className="cue-time">
                <input type="number" step=".1" value={cue.startTime} onClick={(e) => e.stopPropagation()} onChange={(e) => update(index, 'startTime', Number(e.target.value))} />
                <span>→</span>
                <input type="number" step=".1" value={cue.endTime} onClick={(e) => e.stopPropagation()} onChange={(e) => update(index, 'endTime', Number(e.target.value))} />
              </div>
              <button aria-label="Delete cue" onClick={(e) => { e.stopPropagation(); remove(index); }}>
                <SafeIcon icon={FiTrash2} />
              </button>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}